import { Link, useNavigate } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Offcanvas } from 'react-bootstrap';
import './MainNav.css';

const MainNav = (props) => {
  const isLoggedIn = props.isLoggedIn;
  const name = JSON.parse(localStorage.getItem("user")) || "User";
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    navigate('/signin');
  };

  return (
    <Navbar expand="md" variant="dark" className="main-nav">
      <Navbar.Toggle aria-controls="main-navbar-offcanvas" />
      <Navbar.Offcanvas
        id="main-navbar-offcanvas"
        placement="end"
        aria-labelledby="main-navbar-offcanvas-label"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title id="main-navbar-offcanvas-label">
            Menu
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
            <Nav.Link as={Link} to="/documentation">Docs</Nav.Link>
            {isLoggedIn ? (
              <NavDropdown title={`Welcome, ${name}`} align="end" id="user-dropdown">
                <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link as={Link} to="/signin">Login</Nav.Link>
            )}
          </Nav>
        </Offcanvas.Body>
      </Navbar.Offcanvas>
    </Navbar>
  );
};

export default MainNav;
